import { Modal, Button, Alert } from "components/common";
import PropTypes from 'prop-types';
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { changePasswordManageUser } from "redux/authorization/userSlice";
import React from 'react';

const UserDetailChangePassword = ({showModal, setshowModal, user}) => {
  const { register, handleSubmit, formState: {errors}, getValues } = useForm()
  const dispatch = useDispatch()
  
  const onSubmit = (data) => {
    console.log(data)

    try {
      if (user) {
        const userId = user.id
        dispatch(changePasswordManageUser({userId, data}))

        closeModal()
      }
    }
    catch(error) {
      console.log(error.message)
      toast.error(error.message)
    }
  }

  const validatePasswordConfirmation = (value) => {
    const { password } = getValues()
    return password === value || 'Password confirmation does not match.'
  }

  const closeModal = () => {
    setshowModal(false)
  }

  const handleCancel = () => {
    closeModal()
  }

  return (
    <>
      <Modal
        show={showModal}
        onHide={() => setshowModal(false)}
        title="Change password"
        size="md"
        footer={
          <>
            <Button type="submit" form="change-password-form" size="sm">Update</Button>
            <Button variant="danger" size="sm" onClick={handleCancel}>Cancel</Button>
          </>
        }
      >
        <form id="change-password-form" onSubmit={handleSubmit(onSubmit)}>
          <Alert type="warning" message={<>Change password for user <strong className="tw-text-blue-600">{user.name}</strong></>} />

          <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-items-start tw-mb-3">
            <label className="tw-col-span-3 tw-text-sm tw-font-medium tw-text-gray-600 tw-text-right tw-pt-1.5">
              Password
            </label>
            <div className="tw-col-span-9">
              <input
                type="password"
                name="password"
                placeholder="Password"
                autoComplete="new-password"
                className="tw-w-full tw-border tw-border-gray-300 tw-rounded-md tw-px-3 tw-py-1.5 tw-text-sm focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500"
                {...register("password", {
                  required: "Password must be required",
                  minLength: {
                    value: 6,
                    message: "Password must have at least 6 characters"
                  }
                })}
              />
              <span className="tw-text-red-500 tw-text-xs">
                {errors.password && errors.password.message}
              </span>
            </div>
          </div>
          <div className="tw-grid tw-grid-cols-12 tw-gap-2 tw-items-start tw-mb-3">
            <label className="tw-col-span-3 tw-text-sm tw-font-medium tw-text-gray-600 tw-text-right tw-pt-1.5">
              Password confirmation
            </label>
            <div className="tw-col-span-9">
              <input
                type="password"
                name="password_confirmation"
                placeholder="Password confirmation"
                autoComplete="new-password"
                className="tw-w-full tw-border tw-border-gray-300 tw-rounded-md tw-px-3 tw-py-1.5 tw-text-sm focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-blue-500"
                {...register("password_confirmation", {
                  required: "Password confirmation must be required",
                  validate: validatePasswordConfirmation
                })}
              />
              <span className="tw-text-red-500 tw-text-xs">
                {errors.password_confirmation && errors.password_confirmation.message}
              </span>
            </div>
          </div>
        </form>
      </Modal>
    </>
  )
}

UserDetailChangePassword.propTypes = {
  showModal: PropTypes.bool.isRequired,
  setshowModal: PropTypes.bool.isRequired,
  user: PropTypes.object.isRequired
}

export default UserDetailChangePassword;